import http from "@/http-common.js";

class AnaliticsService {

  basePathApiService = "/analitics";
 
  getAll(params) {
    return http.get(this.basePathApiService, params);
  } 

}
export default new AnaliticsService();
